import { render } from "./AdvancedSort.vue?vue&type=template&id=77f666cc&ts=true"
import script from "./AdvancedSort.vue?vue&type=script&lang=ts"
export * from "./AdvancedSort.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__